import "./profy.js"
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// import * as ElIconList from 'element-plus/icons'
// for (const name in ElIconList) {
//   app.component(name, ElIconList[name])
// }

import '@/assets/rem/index'
import { zhCn } from 'element-plus/es/locale'

createApp(App).
    use(store).
    use(router).
    use(ElementPlus, { size: 'small', zIndex: 3000 , locale:zhCn}).
    mount('#app')
